<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <app-table
          ref='drugTable'
          title='Protocol drugs'
          upsert-max-width="900px"
          :readonly='protocol.status !== "INIT" && user.role !== "Administrator"'
          :subtitle='`${protocol.name} - ${protocol.status}`'
          :config="config"
          no-search
          @clone='clone'
          :hidden-fields="{ protocol_id }"
          :filters="{ protocol_id }">
          <template v-slot:headerActions>
            <v-btn
              color="red"
              @click="$router.go(-1)">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </template>
        </app-table>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import config from './config_index.js'
import { getDetail, upsert } from '@/api/base_entity'
import  { mapState } from 'vuex'

export default {
  data () {
    return {
      config,
      protocol: {},
      protocol_id: null
    }
  },
  async created () {
    this.protocol_id= Number(this.$route.params.protocolId)
    this.protocol = await getDetail('protocol', { id: this.$route.params.protocolId })
  },
  computed: mapState(['user']),
  methods: {
    async clone (item) {
      const ret = await this.$root.$confirm.open('Clone drug', `Are you sure to clone the drug <u>${item.name} (${item.packaging} ${item.dose || item.labels}${item.measure_unit})</u>?`)
      if (!ret) return

      const drug = { ...item }
      drug.name = drug.name + '(clone)'
      delete drug.id
      try {
        await upsert('drug', drug)
        this.$refs.drugTable.getData()
      } catch (e) {
          const msg = e && e.response && e.response.data.error_details && Object.values(e.response.data.error_details)[0] || e.response.data.message
          this.$root.$emit('openSnackbar', {
            message: 'Error while cloning: ' +
              msg || 'Error',
            color: 'error'
          })        
      }
    }
  }
}
</script>
